import React, { useEffect, useState } from 'react'
import Each from '../../../../components/Each'
import cogoToast from 'cogo-toast-react-17-fix'
import { useNavigate } from "react-router-dom";
import { ObjectNotEmpty } from '../../../../Utils/helper'
import Modal from '../../../../Utils/Modal';
import SlideUpWrapper from '../../../../components/Transitions/SlideUpWrapper';
import API from "../../../../ApiConfig";
import { GET_HOLDER_DATA } from '../../../../Utils/constant';

import Style from "./Records.module.css"
import dayjs from 'dayjs';
export default function Records({ data, isForm, generateQRLink, Loading }) {
  const [formData, setformData] = useState('');
  const [Popup, setPopup] = useState(false);
  const updatePopup = (bool) => {
    setPopup(bool);
  };
  const handleHolderData = (item) => {
    if (!isForm) {
      if (item.verification_req_id)
        navigate(`../forms/requestDetails/${item.shared_data_id}`);
      else
        navigate(`/dashboard/verifier-data/${item.shared_data_id}`);

    }
  }
  // console.log(formData);
  const navigate = useNavigate()
  const FormData = () => {
    return (
      <>
        <div style={{ display: "flex", justifyContent: "left", alignContent: "center", margin: "1rem", flexDirection: "column", overflowY: "scroll" }}>
          <table border="1" style={{ borderCollapse: 'collapse', width: '100%', borderRadius: "5px" }}>
            <thead>
              {formData.data.map((item, itemIndex) =>
                <tr key={itemIndex}>
                  <th>Authnumber</th>
                  {item.form_data.map((field, index) => (
                    <th key={index} style={{ textAlign: "center", padding: "10px" }}>{field.doc_field_name}</th>
                  ))}
                </tr>
              )}
            </thead>
            <tbody>
              {formData.data.map((item, itemIndex) => (
                <tr key={itemIndex}>
                  <td style={{ textAlign: "center", padding: "10px", fontWeight: "500" }}>{item.authnumber}</td>
                  {item.form_data.map((field, index) => (
                    <td style={{ textAlign: "center", padding: "10px", fontWeight: "500" }} key={index}>{field.consented_data}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>

      </>
    )
  }
  function handleViewDetail(item) {
    if (isForm) {
      navigate(`/dashboard/forms/${item.form_uuid}`, { state: { 'formType': item.form_type } })
    }
  }

  return (
    <>
      <SlideUpWrapper direction="slide-left">
        <div className="credentials-table">
          <table border="0">
            <thead>
              <tr className="credentials-header bg-lgray">
                {/* <th className="credentials-th">
                  <div className="credentials-table-text">Sr. no</div>
                </th> */}
                <th className="credentials-th">
                  <div className="credentials-table-text">User Name</div>
                </th>
                <th className="credentials-th">
                  <div className="credentials-table-text">Form Name</div>
                </th>
                {isForm ? <>
                  <th className="credentials-th flex-grow-2"><div className="credentials-table-text">Data Fields</div></th>
                  <th className="credentials-th"><div className="credentials-table-text">Verifications</div></th>
                  <th className="credentials-th">
                    <div className="credentials-table-text">Created At</div>
                    <img className="chevronSortIcon" alt="" src="/chevronsort.svg" />
                  </th>
                  <th className="credentials-th">
                    <div className="credentials-table-text">Status</div>
                  </th>
                </> : null}
                {!isForm ? <>
                  <th className="credentials-th flex-grow-1">
                    <div className="credentials-table-text">Submission On</div>
                  </th>
                  <th className="credentials-th flex-grow-1">
                    <div className="credentials-table-text">Source</div>
                  </th>
                  {/* <th className="credentials-th flex-grow-2">
                    <div className="credentials-table-text">Holder ID</div>
                  </th> */}
                </> : null
                }
                <th className="credentials-th flex-grow-2">
                  <div className="credentials-table-text">Actions</div>
                </th>
              </tr>
            </thead>

            <tbody className='Table-Content' style={data.length <= 6 ? { overflowY: "hidden" } : null}>
              {ObjectNotEmpty(data) ?
                data.map((item, item_index) => Object.keys(item).map((key, index) => {
                  return <tr className="credentials-header1" key={index}>
                    {/* <td className="credentials-th">
                <div className="credentials-table-text">{item_index+1}.</div>
              </td> */}
                    <td className="credentials-td">
                      <div className={Style.td + " credentials-table-text c-primary"}>{item[key][0].user_name? item[key][0].user_name:null}</div>
                    </td>
                    <td className="credentials-td">
                      <div className={Style.td + " credentials-table-text c-primary"}>{item[key][0].form_name}</div>
                    </td>
                    {isForm ? <>
                      <td className="credentials-td flex-grow-2">
                        <div className={Style.td + " credentials-table-text"}>
                          <div>
                            {item[key].map((Item, i) => <span>{Item.doc_field_name}{i < item[key].length - 1 ? <span>, </span> : null}</span>)}</div>
                        </div>
                      </td>
                      <td className="credentials-td">
                        <div className={Style.td + " credentials-table-text"}>{item[key][0].no_of_submissions}</div>
                      </td>
                      <td className="credentials-td">
                        <div className={Style.td + " credentials-table-text"}>{dayjs(item[key][0].created_at).format('DD MMM YYYY')}</div>
                      </td>
                      <td className="credentials-td">
                        <div className={Style.td + " credentials-table-text"}>{item[key][0].status}</div>
                      </td>
                    </>
                      : null}
                    {!isForm ?
                      <>
                        <td className="credentials-td flex-grow-1">
                          <div className={Style.td + " credentials-table-text"}>
                            {dayjs(item[key][0].data_submission_date).format('DD MMM YYYY')} - {dayjs.utc(item[key][0].data_submission_date).format('HH:mm')}
                          </div>
                        </td>
                        <td className="credentials-td flex-grow-2">
                          <div className={Style.td + " credentials-table-text"}>{item[key][0].verification_req_id ? 'Requested' : 'QR'}</div>
                        </td>
                        {/* <td className="credentials-td flex-grow-2">
                          <div className={Style.td + " credentials-table-text"}>{item[key][0].holder_id}</div>
                        </td> */}
                      </> : null}
                    <td className="credentials-td flex-grow-2">
                      <div className={Style.actionContainer + " credentials-table-text"}>
                        <div className="btn btn-primary" onClick={() => { isForm ? handleViewDetail(item[key][0]) : handleHolderData(item[key][0]) }}>View Detail</div>
                        <Modal title={"Form_uuid: " + item[key][0].form_uuid} isOpen={Popup} onClose={updatePopup} blockOutsideClick={true} children={<FormData />} />
                        {isForm ? <div className={Style.button + " primaryBtn btn-sm btn-primary ml-1"} onClick={() => generateQRLink(item[key][0])}>Share QR</div> : null}
                      </div>
                    </td>
                  </tr>
                }))
                : Loading && isForm ? (
                  [...Array(2)].map((_, index) => (
                    <tr className='credentials-header' key={index}>
                      <td className="credentials-th flex-grow-2">
                        <div className="shimmer" style={{ width: '7rem' }}></div>
                      </td>
                      <td className="credentials-th flex-grow-2">
                        <div className="shimmer" style={{ width: '7rem' }}></div>
                      </td>
                      <td className="credentials-th flex-grow-2">
                        <div className="shimmer" style={{ width: '7rem' }}></div>
                      </td>
                      <td className="credentials-th flex-grow-2">
                        <div className="shimmer" style={{ width: '7rem' }}></div>
                      </td>
                      <td className="credentials-th">
                        <div style={{ display: "flex", justifyContent: "space-between", gap: "1rem" }}>
                          <div className="shimmer" style={{ width: '4rem', height: "2rem" }}></div>
                          <div className="shimmer" style={{ width: '4rem', height: "2rem" }}></div>
                        </div>
                      </td>
                    </tr>))
                ) : !isForm && Loading ?
                  [...Array(2)].map((_, index) => (
                    <tr className='credentials-header' key={index}>
                      <td className="credentials-th flex-grow-2">
                        <div className="shimmer" style={{ width: '7rem' }}></div>
                      </td>
                      <td className="credentials-th flex-grow-2">
                        <div className="shimmer" style={{ width: '7rem' }}></div>
                      </td>
                      <td className="credentials-th flex-grow-2">
                        <div className="shimmer" style={{ width: '7rem' }}></div>
                      </td>
                      <td className="credentials-th flex-grow-2">
                        <div className="shimmer" style={{ width: '7rem' }}></div>
                      </td>
                      <td className="credentials-th">
                        <div style={{ display: "flex", justifyContent: "space-between", gap: "1rem" }}>
                          <div className="shimmer" style={{ width: '4rem', height: "2rem" }}></div>
                        </div>
                      </td>
                    </tr>)) : <tr className="credentials-tr">
                    <td colSpan="6" className="credentials-td text-center">
                      <div className="Data_List">No Data Found</div>
                    </td>
                  </tr>
              }
            </tbody>
          </table>

        </div >
      </SlideUpWrapper>
    </>
  )
}
